export default __webpack_public_path__ + "static/lalibrairie-c-mobile-0a1a3470c0855091593f7a8a5145e39d.jpg";